/** Normalize email or Saudi mobile for login / reset-password APIs. */
export function normalizeLoginIdentifier(raw: unknown): string {
  const trimmed = (raw ?? "").toString().trim();
  if (!trimmed) return "";

  if (trimmed.includes("@")) return trimmed;

  let phone = trimmed.replace(/\D/g, "");
  if (phone.startsWith("00966")) phone = phone.slice(5);
  else if (phone.startsWith("966")) phone = phone.slice(3);
  if (phone.startsWith("0")) phone = phone.slice(1);

  return phone;
}

export function isValidLoginIdentifier(raw: unknown): boolean {
  const value = (raw ?? "").toString().trim();
  if (!value) return false;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(value)) return true;

  const phone = normalizeLoginIdentifier(value);
  return /^[0-9]{6,15}$/.test(phone);
}
